import React from 'react';

import styled, { css } from 'styled-components';

import { theme } from 'fpay-ui';

const fontTypes = {
  title: css`
    ${({ theme }) => theme.textTypes['Subtitle-1-w500']};
    line-height: 1.31;
    color: ${theme.colors.gray700};
  `,
  text: css`
    ${({ theme }) => theme.textTypes['H6-w400']};
    color: ${theme.colors.gray800};
    line-height: 1.2;
  `,
  button: css`
    ${({ theme }) => theme.textTypes['Body-2-w400']};
    line-height: normal;
  `,
};

const Layout = styled.div`
  padding-top: 12px;
  padding-bottom: 24px;
  padding-left: 24px;
  padding-right: 24px;
`;

const Text = styled.div`
  white-space: pre-line;
  ${fontTypes.text}
  margin-top: 16px;
  text-align: center;
`;

const LayoutButtons = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const Button = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: center;
    ${fontTypes.button}
    text-align: center;
    align-items: center;
    width: 120px;
    height: 40px;
    border-radius: 4px;
    background-color: ${(props) => (props.noThanks ? '#ffffff' : `${theme.colors.gbrand500}`)};
    color: ${(props) => (props.noThanks ? `${theme.colors.gbrand500}` : '#ffffff')};
    cursor: pointer;
    transition: all 0.3s ease 0s;
    &:hover {
      box-shadow: ${(props) => (props.noThanks ? '' : '0 1px 6px rgb(32 33 36 / 28%)')};
      background-color: ${(props) => (props.noThanks ? '' : `${theme.colors.gbrand600}`)};
      color: ${(props) => (props.noThanks ? `${theme.colors.gbrand600}` : '#ffffff')};
    }
    &:active {
      border: ${(props) => (props.noThanks ? '' : `1px solid ${theme.colors.gbrand500}`)};
    }
  `
);

const ModalTransferPe = ({ text, handleConfirm, handleCancel, textConfirm, textCancel }) => {
  return (
    <Layout>
      <Text>{text}</Text>
      <LayoutButtons>
        <Button noThanks onClick={handleCancel}>
          {textCancel}
        </Button>
        <Button onClick={handleConfirm}>{textConfirm}</Button>
      </LayoutButtons>
    </Layout>
  );
};

export default ModalTransferPe;
